var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_19016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_19016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_19016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90156 10.7984L12.0016 2.39844L17.1016 10.7984H6.90156ZM17.4016 21.5984C16.2349 21.5984 15.2432 21.1901 14.4266 20.3734C13.6099 19.5568 13.2016 18.5651 13.2016 17.3984C13.2016 16.2318 13.6099 15.2401 14.4266 14.4234C15.2432 13.6068 16.2349 13.1984 17.4016 13.1984C18.5682 13.1984 19.5599 13.6068 20.3766 14.4234C21.1932 15.2401 21.6016 16.2318 21.6016 17.3984C21.6016 18.5651 21.1932 19.5568 20.3766 20.3734C19.5599 21.1901 18.5682 21.5984 17.4016 21.5984ZM3.60156 20.9984V13.7984H10.8016V20.9984H3.60156ZM17.3958 19.7984C18.0663 19.7984 18.6349 19.567 19.1016 19.1042C19.5682 18.6412 19.8016 18.0745 19.8016 17.4042C19.8016 16.7337 19.5701 16.1651 19.1073 15.6984C18.6443 15.2318 18.0776 14.9984 17.4073 14.9984C16.7368 14.9984 16.1682 15.2299 15.7016 15.6927C15.2349 16.1557 15.0016 16.7224 15.0016 17.3927C15.0016 18.0632 15.233 18.6318 15.6958 19.0984C16.1588 19.5651 16.7255 19.7984 17.3958 19.7984ZM5.40156 19.1984H9.00156V15.5984H5.40156V19.1984ZM10.1016 8.99844H13.9016L12.0016 5.87344L10.1016 8.99844Z",
    fill: "#3F25AE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_19016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.3ca1d43b7802d501e372f424c5516ab7.svg";
export { ForwardRef as ReactComponent };